import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
export const InlineTooltip = ({
  tooltip,
  icon,
  direction = 'left'
}) => <div className="foundry--tooltip--wrapper toggles__tooltip">
    <div className={`foundry--tooltip tooltip--${direction} tooltip--custom-position tooltip--hover list-type-tooltip`}>
      {tooltip}
    </div>
    <div className="foundry--tooltip-icon">
      <FontAwesomeIcon icon={icon} className="tooltip--icon" />
    </div>
  </div>;